import React from 'react';
import LsRequestsList from '../../ls-requests/LsRequestsList';

const AllMyLs = () => {
  return <LsRequestsList />;
};

export default AllMyLs;
